import { MY_ITINERARY_LIST } from '../actions';

export const myItineraryListReducer = (state = [], action) => {
  if (action.type === MY_ITINERARY_LIST) return action.payload;
  return state;
};
